import React from 'react'
import { useParams } from 'react-router-dom'
import UserInfo from './UserInfo'
import NumberSelection from './NumberSelection'
import ServiceAgreement from './ServiceAgreement'
import Activation from './Activation'
import { useSelector } from 'react-redux'
import Invoice from './Invoice'

const StepContents = () => {
    const isFreeProduct = useSelector((state: any) => state.purchaseReducer.getIsFreeProductResult)
    const params = useParams()
    return (
        <div className='main-step-contents'>
            {params.step === 'step-1' && <UserInfo />}
            {params.step === 'step-2' && <NumberSelection />}
            {params.step === 'step-3' && <ServiceAgreement />}
            {(params.step === 'step-4' && isFreeProduct) ? <Activation /> : (params.step === 'step-4' && !isFreeProduct) ? <Invoice /> : ""}
            {params.step === 'step-5' && <Activation />}


        </div>
    )
}

export default StepContents